import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Tickets from "@/pages/Tickets";
import TicketDetail from "@/pages/TicketDetail";
import Milestones from "@/pages/Milestones";
import SeoReports from "@/pages/SeoReports";
import Marketing from "@/pages/Marketing";
import Competitors from "@/pages/Competitors";
import ContentStudio from "@/pages/ContentStudio";
import SeoToolkit from "@/pages/SeoToolkit";
import Social from "@/pages/Social";
import Reports from "@/pages/Reports";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Settings from "@/pages/Settings";
import Users from "@/pages/Users";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/tickets" element={<Tickets />} />
              <Route path="/tickets/:id" element={<TicketDetail />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/projects/:id" element={<ProjectDetail />} />
              <Route path="/settings" element={<Settings />} />
              <Route
                path="/users"
                element={
                  <ProtectedRoute staffOnly>
                    <Users />
                  </ProtectedRoute>
                }
              />
              <Route path="/milestones" element={<Milestones />} />
              <Route path="/seo" element={<SeoReports />} />
              <Route path="/marketing" element={<Marketing />} />
              <Route path="/competitors" element={<Competitors />} />
              <Route path="/content" element={<ContentStudio />} />
              <Route path="/toolkit" element={<SeoToolkit />} />
              <Route path="/social" element={<Social />} />
              <Route
                path="/clients"
                element={
                  <ProtectedRoute staffOnly>
                    <Clients />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/clients/:id"
                element={
                  <ProtectedRoute staffOnly>
                    <ClientDetail />
                  </ProtectedRoute>
                }
              />
            </Route>
          </Routes>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
